import React, { useState, useEffect } from "react";

const HistoryPredictionsView = ({ year, predictions }) => {
  const [questions, setQuestions] = useState([]);

  useEffect(() => {
    if (
      predictions &&
      predictions.predictions &&
      Array.isArray(predictions.predictions)
    ) {
      const questions = predictions.predictions
        .filter((prediction) => prediction && prediction.text) // Filter out empty or invalid questions
        .map((prediction, index) => {
          return {
            text: prediction.text || "",
            taskid:
              prediction.taskid || prediction.questionId || `temp-${index}`,
            questionId:
              prediction.questionId || prediction.taskid || `temp-${index}`,
            // Add more fields as needed
          };
        });

      setQuestions(questions);
    } else {
      setQuestions([]);
    }
  }, [predictions]); // Include in the dependency array

  return (
    <div className="col">
      <div className="">
        <div className="">
          <div className="">
            {/* Render questions directly */}
            <ul>
              {questions.length > 0 ? (
                questions.map((question, index) => (
                  <div
                    className="sub-card p-0"
                    key={question.taskid || question.questionId || index}
                  >
                    <div className="task-card-data">
                      <div className="">
                        <div>
                          <p>{question.text}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                ))
              ) : (
                <p>No questions available for this year.</p>
              )}
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HistoryPredictionsView;
